import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { InsightsService } from '../../services/insights-service';

/**
 * Guard that allows activation only when the app is on the Insights domain.
 * Does not require the user to have Insights access (use for e.g. request-access page).
 */
@Injectable({
  providedIn: 'root',
})
export class InsightsDomainOnlyGuard {
  constructor(private insightsService: InsightsService) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    return this.insightsService.isInsightsDomain();
  }
}
